import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import ListBimClassRevisions from "../ListBimClassRevisions.graphql";
import RevisionInventory from "./RevisionInventory";

export default function BimClassRevisions(props) {
    const { guard, id, revisionID } = props;

    const listBimClassRevisions = useQuery(
        gql(ListBimClassRevisions),
        {
            variables: {
                id,
            },
        },
    );

    if (listBimClassRevisions.loading) return "loading";
    if (listBimClassRevisions.error) return "error";

    return (
        <RevisionInventory
            guard={ guard }
            revisions={ listBimClassRevisions.data?.bimClasses }
            selectedRevisionID={ revisionID }
        />
    );
}
